<mat-card>
  <div class="row" class="btnActions">
    <div class="btnLeft">
      <h2>
        {{ 'request.documentation.title' | translate }} <i>{{ docId }}</i>
      </h2>
    </div>
    <div *ngIf="hasAttachAttribution()" class="btnRight">
      <button mat-flat-button color="accent" (click)="onClickAttach(operation)">
        <span translate>request.update</span>
      </button>
    </div>
  </div>

  <div class="table__wrapper">
    <table aria-label="documentation" mat-table [dataSource]="documentation">
      <ng-container matColumnDef="revision">
        <th mat-header-cell *matHeaderCellDef translate>
          {{ 'request.documentation.review' | translate | uppercase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.document }}</td>
      </ng-container>
      <ng-container matColumnDef="comprobado">
        <th mat-header-cell *matHeaderCellDef translate>request.documentation.status</th>
        <td mat-cell *matCellDef="let element" translate>
          {{ getDocumentStatus(element.documentStatus) }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-card>
